
import axios, { AxiosResponse } from 'axios';
import _ from "lodash";
import {  API_GATEWAY_URL }  from "../config/constants";

interface EventUser {
  id: string;
}

interface Speaker {
  id: string;
  name: string;
  // add other properties as needed
}

interface PanelDiscussion {
  id: string;
  panelist: Speaker[];
  // add other properties as needed
}

export const fetchEventParticipantCount = async (eventId: string): Promise<EventUser[]> => {
  try {
   const response = await axios.get(API_GATEWAY_URL + `frontend/api/event-user/${eventId}/participants`, {
    headers: {
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        'Pragma': 'no-cache',
        'Expires': '0',
      }
    });

   return _.get(response, 'data.data', []).length;
  } catch (error) {
    console.error("Error fetching exhibitors:", error);
    return [];
  }
};

export const fetchSpeakersAndPanelists = async (eventId: string): Promise<number> => {
    try {
    const configs = {
        headers: {
            "Cache-Control": "no-cache, no-store, must-revalidate",
            Pragma: "no-cache",
            Expires: "0",
        },
    };
    const [speakerResp, panelistResp]: [AxiosResponse<{ data: Speaker[] }>, AxiosResponse<{ data: PanelDiscussion[] }>] = 
      await Promise.all([
        axios.get(`${API_GATEWAY_URL}frontend/api/event-user/${eventId}/speakers`, configs),
        axios.get(`${API_GATEWAY_URL}frontend/api/panel-discussions/event-id/${eventId}`, configs)
      ]);

    const speakerCount = _.get(speakerResp, "data.data", []).length;
   // const panelistCount = _.size(_.flatten(_.map(_.get(panelistResp, "data.data", []), "panelist")));
    return speakerCount ;

    }catch (error) {
        console.error("Error fetching speakers and panelists:", error);
        return 0; // Return 0 in case of an error
    }
}
